 <app-form-input 
[parentForm]="parentForm" 
[value]="attributionSansNegociation.oui" 
 
[label]="step9.getoui"
[type]="'tofix'"
[name]="getUid()+'_SepAtt_oui'">
</app-form-input>


<app-form-input 
[parentForm]="parentForm" 
[value]="attributionSansNegociation.non" 
 
[label]="step9.getnon"
[type]="'tofix'"
[name]="getUid()+'_SepAtt_non'">
</app-form-input>